import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

class ScrollEvent {
	constructor(
		readonly scrollTop: number,
		readonly scrollHeight: number,
		readonly clientHeight: number
	) {}
}

export class ScrollAction {
	constructor(readonly scrollTop: number) {}
}

@Injectable({ providedIn: 'root' })
export class ScrollService {
	private readonly scrolledSubject = new Subject<ScrollEvent>();
	private readonly scrollActionSubject = new Subject<ScrollAction>();

	emit(scrollEvent: ScrollEvent) {
		this.scrolledSubject.next(scrollEvent);
	}

	setScroll(scrollAction: ScrollAction) {
		this.scrollActionSubject.next(scrollAction);
	}

	scrolledAsObservable() {
		return this.scrolledSubject.asObservable();
	}

	scrollActionAsObservable() {
		return this.scrollActionSubject.asObservable();
	}
}
